import { type RefObject, useEffect, useMemo } from "react";

/**
 * Pass all aria-* attributes
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAriaAttributes = (props: any) => {
  return useMemo(() => {
    const ariaAttributes: Record<string, string> = {};

    for (const key of Object.keys(props)) {
      if (key.startsWith("aria-")) {
        ariaAttributes[key] = props[key];
      }
    }

    return ariaAttributes;
  }, [props]);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useSetAriaAttributesToRef = (props: any, ref: RefObject<HTMLElement | null>) => {
  const ariaAttributes = useAriaAttributes(props);

  useEffect(() => {
    if (ref.current) {
      for (const [key, value] of Object.entries<string>(ariaAttributes)) {
        ref.current.setAttribute(key, value);
      }
    }
  }, [ariaAttributes, ref]);
};
